import { nanoid } from "nanoid";
export var generateToastId = function generateToastId() {
  return nanoid(10);
};